import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n";
import { apiErrorMessage } from "../lib/api";

export default function RegisterStreamer() {
  const [form, setForm] = useState({ displayName: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { registerStreamer } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await registerStreamer(form);
      toast.success("Streamer profile created. Confirm your email to continue.");
      nav("/streamer/onboarding");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Registration failed"));
    } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="max-w-lg mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">{t("auth.streamerSignupEyebrow")}</div>
      <h1 className="font-display text-4xl font-black tracking-tighter mb-8">{t("auth.registerStreamer")}</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="register-streamer-form">
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.displayName")}</Label>
          <Input data-testid="rs-name" required value={form.displayName} onChange={set("displayName")} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.email")}</Label>
          <Input data-testid="rs-email" type="email" required value={form.email} onChange={set("email")} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.password")}</Label>
          <Input data-testid="rs-password" type="password" required minLength={8} value={form.password} onChange={set("password")} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
        </div>
        <Button data-testid="rs-submit" type="submit" disabled={busy} className="w-full rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-12 font-semibold transition-colors">
          {busy ? t("common.loading") : t("auth.registerStreamer")}
        </Button>
      </form>
      <div className="mt-6 text-sm text-[#8B97AE]">
        {t("auth.haveAccount")}{" "}
        <Link to="/login" className="text-white underline hover:text-[#2DD4A7]" data-testid="rs-goto-login">{t("nav.login")}</Link>
      </div>
    </div>
  );
}
